
export default {
  props: {
    id: { type: [String, Number], default: null },
    items: { type: Array, default: null },
    subTitle: { type: String, default: null },
    title: { type: String, default: null },
    background: { type: Object, default: null },
    pushTitle: { type: String, default: null },
    pushItem: { type: Object, default: null },
  }
};
